<!-- <form [formGroup]="_myForm">
  <div class="col-12"> -->
<taku-person [formGroup]="_myForm.controls['person']"></taku-person>
<!-- </div>
</form> -->
